import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IVendorOfferListResponse, IVendorOfferWithoutVendorConfiguration} from "../../offer/types/VendorOffersListResponse";
import {convertToVendorDetailViewOffersPayload} from "../utils/convert_to_vendor_detail_view_offers_payload";

export const getVendorDetailOfferListMap = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getVendorDetailOfferListMap: builder.query<IVendorOfferWithoutVendorConfiguration[], {vendor: number}>({
            queryFn: async ({vendor}, _api, _extra, fetchWithBQ) => {
                const initialFetch = await fetchWithBQ({
                    url: apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST),
                    params: convertToVendorDetailViewOffersPayload({vendorId: vendor, region: null, displayType: OfferDisplayType.FOR_SALE})
                });
                if (initialFetch.error) {
                    return {error: initialFetch.error};
                }
                const data = initialFetch.data as IVendorOfferListResponse;
                const totalPage = Math.ceil(data.count / data.page_size);
                const pages = Array.from({length: totalPage}, (_, i) => i + 1);

                const responses = (await Promise.all(
                    pages.map((page) =>
                        fetchWithBQ({
                            url: apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST),
                            params: {...convertToVendorDetailViewOffersPayload({vendorId: vendor, region: null, displayType: OfferDisplayType.FOR_SALE}), page}
                        })
                    )
                )) as {
                    data: IVendorOfferListResponse;
                    error?: FetchBaseQueryError;
                }[];

                const firstError = responses.find((r) => r.error)?.error;
                if (firstError) {
                    return {error: firstError};
                }

                const allOffers = responses.flatMap((r) => r.data.results);
                return {data: allOffers};
            }
        })
    })
});

export const {useGetVendorDetailOfferListMapQuery} = getVendorDetailOfferListMap;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IVendorOfferListResponse, IVendorOfferWithoutVendorConfiguration} from "../../offer/types/VendorOffersListResponse";
import {convertToVendorDetailViewOffersPayload} from "../utils/convert_to_vendor_detail_view_offers_payload";

export const getVendorDetailOfferListMap = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getVendorDetailOfferListMap: builder.query<IVendorOfferWithoutVendorConfiguration[], {vendor: number}>({
            queryFn: async ({vendor}, _api, _extra, fetchWithBQ) => {
                const initialFetch = await fetchWithBQ({
                    url: apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST),
                    params: convertToVendorDetailViewOffersPayload({vendorId: vendor, region: null, displayType: OfferDisplayType.FOR_SALE})
                });
                if (initialFetch.error) {
                    return {error: initialFetch.error};
                }
                const data = initialFetch.data as IVendorOfferListResponse;
                const totalPage = Math.ceil(data.count / data.page_size);
                const pages = Array.from({length: totalPage}, (_, i) => i + 1);

                const responses = (await Promise.all(
                    pages.map((page) =>
                        fetchWithBQ({
                            url: apiV2ListLink.offer.list(Scenario.VENDOR_DETAIL_OFFER_LIST),
                            params: {...convertToVendorDetailViewOffersPayload({vendorId: vendor, region: null, displayType: OfferDisplayType.FOR_SALE}), page}
                        })
                    )
                )) as {
                    data: IVendorOfferListResponse;
                    error?: FetchBaseQueryError;
                }[];

                const firstError = responses.find((r) => r.error)?.error;
                if (firstError) {
                    return {error: firstError};
                }

                const allOffers = responses.flatMap((r) => r.data.results);
                return {data: allOffers};
            }
        })
    })
});

export const {useGetVendorDetailOfferListMapQuery} = getVendorDetailOfferListMap;
